/**
 * OAuth popup relay. Kept free of imports so the islands entry can install
 * it at load time without pulling in the Supabase client early.
 */

let oauthRelayOff: (() => void) | null = null

/**
 * The OAuth popup lands on /crm/oauth-done/, which posts its result to
 * `window.opener`. Google and Zoho sign-in pages can cut that link, so the
 * page falls back to a same-origin BroadcastChannel; this relays those
 * messages into the window `message` event every listener already uses.
 */
export function installOAuthRelay(): () => void {
  if (oauthRelayOff) return oauthRelayOff
  if (typeof BroadcastChannel === 'undefined') return () => {}
  const bc = new BroadcastChannel('hunts-oauth')
  bc.onmessage = (ev: MessageEvent) => {
    const d = ev?.data as { type?: unknown } | null
    if (!d || typeof d !== 'object' || typeof d.type !== 'string') return
    if (!/^(google|zoho)-oauth-(success|error)$/.test(d.type)) return
    window.postMessage(d, window.location.origin)
  }
  oauthRelayOff = () => {
    bc.close()
    oauthRelayOff = null
  }
  return oauthRelayOff
}
